import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 70%;
  margin: 0 auto;
`;

export const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  width: 70%;
  margin: 24px auto 0;
`;

export const SectionContainer = styled.div`
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.white};
  padding: 24px;
`;

export const SectionHeader = styled.h3`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-weight: 400;
  margin: 0 0 20px 0;
`;

export const FieldRow = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FieldLabel = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 4px 0;
`;

export const FieldHelper = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 13px;
  font-weight: 400;
  margin: 0 0 8px 0;
`;

export const ZoneText = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  margin: 0;
`;

export const RequiredIndicator = styled.span`
  color: ${({ theme }) => theme.palette.error.main};
  margin-left: 2px;
`;

export const PreviewContainer = styled.div`
  background: ${({ theme }) => theme.palette.action.hover};
  border-radius: 8px;
  padding: 16px 20px;
  margin-top: 12px;
`;

export const PreviewHeader = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 12px 0;
`;

export const PreviewList = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const PreviewRow = styled.li`
  display: flex;
  gap: 12px;
  padding: 6px 0;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.primary};

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  }
`;

export const PreviewIndex = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  min-width: 24px;
`;

export const PreviewDates = styled.span`
  font-variant-numeric: tabular-nums;
`;

export const PreviewSpinner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 13px;
`;

export const PreviewRefreshIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  vertical-align: middle;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const PreviewError = styled.p`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 13px;
  margin: 0;
`;
